module.exports = __webpack_public_path__ + "img/IMG6_Haversian_Remodeling_D3.8917fbff.jpg";